<template>
  <div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <v-speed-dial
      v-model="fab"
      bottom
      direction="top"
      :open-on-hover="true"
      transition="slide-y-reverse-transition"
      id="FloatingButton"
    >
      <!-- <v-btn
        fab
        dark
        small
        style="background-color: white;"
        @click="stampajMerenja"
      >
      <img
          data-v-68a7a11e=""
          title="Merenja"
          src="../../assets/icons/merenje.svg"
        />
      </v-btn>
      <v-btn
        fab
        dark
        small
        style="background-color: white"
        @click="stampaj"
      >
      <img
          data-v-68a7a11e=""
          title="Dodavanja"
          src="../../assets/icons/dodavanje.svg"
        />
      </v-btn> -->
      <v-btn
        fab
        dark
        small
        style="background-color: white"
        @click="stampajPromene"
      >
        <img
          data-v-68a7a11e=""
          title="Promene"
          src="../../assets/icons/pretakanje.svg"
        />
      </v-btn>
      <v-btn
        fab
        dark
        small
        style="
          background-color: white;
          color: #018389;
          border: #018389;
          border-style: solid;
          border-width: 0.1px;
        "
        @click="stampajSve"
      >
        <v-icon title="Sve operacije"> event_note </v-icon>
      </v-btn>
    </v-speed-dial>
  </div>
</template>

<script>
import { serverBus } from "../../main";

import Loading from "vue-loading-overlay";
import html2pdf from "html2pdf.js";
import {
  readJSON,
  prevediSveOperacije,
  getDateTime,
} from "../../helpers/Functions";

const MountedMixin = {
  mounted() {
    // alert(222222);
    this.$emit("mounted");
  },
};

export default {
  name: "FloatingButton",
  dialog: false,
  props: [
    "items",
    "tip_tanka",
    "selectedTabDodaci",
    "items_dodaci",
    "selectedTabMerenja",
    "items_merenja",
    "items_promene",
    "tank_phase_vineId",
    "selectedTab",
  ],
  watch: {
    items: function (val) {},
    tip_tanka: function (val) {},
    selectedTabDodaci: function (val) {},
    items_dodaci: function (val) {},
    selectedTabMerenja: function (val) {},
    items_merenja: function (val) {},
    items_promene: function (val) {
      
    },
    tank_phase_vineId: function (val) {},
    selectedTab: function (val) {},
  },
  data() {
    return {
      akcija: "1",
      // idRoom: 0,
      naziv_prostorije: "",
      makaClass: "maksimalna_velicina",

      direction: "top",
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-x-reverse-transition",
      operationTypeLok: undefined,
      isLoading: false,
      fullPage: true,
      naslov: "",
      naziv_fajla: "",
      json_fields_type: [],
      json_fields: {},
      json_data: [],
    };
  },
  components: {
    Loading,
  },
  methods: {
    formatTank_U(stringLok, nazivTanka) {
      let pomStr = "";

      if (stringLok == "OUT") pomStr = nazivTanka;
      else pomStr = "";
      return pomStr;
    },
    formatTank_IZ(stringLok, nazivTanka, item) {
      let pomStr = "";

      if (stringLok === "IN") pomStr = nazivTanka;
      else {
        if (item !== null) pomStr = this.formatImena(item);
      }
      return pomStr;
    },
    formatImena(item) {
      let returnText = "";

      if (
        item.tankFromBatchInOperations !== undefined &&
        item.tankFromBatchInOperations !== null
      )
        if (item.tankFromBatchInOperations.length === 0) returnText = "";
        else {
          if (
            item.tankFromBatchInOperations.length % 10 === 1 &&
            item.tankFromBatchInOperations.length !== 11
          )
            returnText = item.tankFromBatchInOperations.length + " barik";
          else returnText = item.tankFromBatchInOperations.length + " barika";
        }

      return returnText;
    },
    formatDateTime(date) {
      if (typeof date !== "undefined" && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    formatDate(date) {
      if (typeof date !== "undefined" && date !== null) {

        let month = date.split("-")[1];
        let day = date.split("-")[2];
        const year = date.split("-")[0];

        return [day, month, year].join(".");
      } else return "";
    },
    prevediOperacijeLok(stringLok, frakcija) {
      let pomStr = "";

      pomStr = prevediSveOperacije(stringLok);

      if (stringLok === "PRESSING" && frakcija !== null)
        pomStr = pomStr + " - " + frakcija;

      return pomStr;
    },
    stampaj() {
      

      let _this = this;
      this.isLoading = true;

      this.naziv_fajla = "dodavanja.xls";

      if (this.tip_tanka === 15) {
        if (this.selectedTabDodaci === 0)
          this.naslov = "Dodavanja u šaržu " + this.items.tank.name;
        else
          this.naslov =
            "Prethodna dodavanja u vino iz šarže " + this.items.tank.name;

        this.json_fields = {
          Rb: "String",
          Datum: "Date",
          Barik: "String",
          Dodatak: "String",
          Količina: "Number",
          Tank: "String",
          Faza: "String",
          Vino: "String",
          "Na količinu": "Number",
        };

        this.json_fields_type = [
          "String",
          "Date",
          "String",
          "String",
          "Number",
          "String",
          "String",
          "String",
          "Number",
        ];
      } else {
        if (this.selectedTabDodaci === 0)
          this.naslov = "Dodavanja u tank " + this.items.tank.name;
        else
          this.naslov =
            "Prethodna dodavanja u vino iz tanka " + this.items.tank.name;

        this.json_fields = {
          Rb: "String",
          Datum: "Date",
          Dodatak: "String",
          Količina: "Number",
          Tank: "String",
          Faza: "String",
          Vino: "String",
          "Na količinu": "Number",
        };

        this.json_fields_type = [
          "String",
          "Date",
          "String",
          "Number",
          "String",
          "String",
          "String",
          "Number",
        ];
      }

      this.json_data = [];
      let rbr = 1;

      this.items_dodaci.forEach(function (entry) {
        let objekat;

        if (_this.tip_tanka === 15) {
          let spisakBarika = "";

          if (entry.tankFromBatchInOperations.length > 0)
            entry.tankFromBatchInOperations.forEach(function (e) {
              if (spisakBarika !== "")
                spisakBarika =
                  spisakBarika + ", " + e.tank.batchPrefix + "|" + e.tank.name;
              else spisakBarika = e.tank.batchPrefix + "|" + e.tank.name;
            });
          else spisakBarika = "Svi barici";

          objekat = {
            Rb: rbr,
            Datum: _this.formatDateTime(entry.date),
            Barik: spisakBarika,
            Dodatak: entry.name,
            Količina: entry.quantity + " " + entry.unitOfMeasure,
            Tank: entry.tankName,
            Faza: entry.phaseAtMoment,
            Vino: entry.wineAtMoment,
            "Na količinu":
              entry.wineQuantityAtMoment +
              " " +
              entry.wineQuantityAtMomentUnitOfMeasure,
          };
        } else
          objekat = {
            Rb: rbr,
            Datum: _this.formatDateTime(entry.date),
            Dodatak: entry.name,
            Količina: entry.quantity + " " + entry.unitOfMeasure,
            Tank: entry.tankName,
            Faza: entry.phaseAtMoment,
            Vino: entry.wineAtMoment,
            "Na količinu":
              entry.wineQuantityAtMoment +
              " " +
              entry.wineQuantityAtMomentUnitOfMeasure,
          };

        _this.json_data.push(objekat);

        rbr = rbr + 1;
      });

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var isLastElement = i == _this.json_data.length - 1;

          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            if (val === null || val === 0 || val === "")
              cellText = document.createTextNode("-");
            else cellText = document.createTextNode(val);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (
              _this.json_fields_type[pomJ] === "Number" ||
              _this.json_fields_type[pomJ] === "StringRight"
            ) {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          if (isLastElement) {
            poslednjiRed = row;
            // row.setAttribute("border", "none");
          }

          tblBody.appendChild(row);
        });

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        var tblBody = document.createElement("tbody");

        tbl.style.margin = "20px 0px 0px 75%";
        tbl.style.width = "25%";
        // tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // tblBody.appendChild(poslednjiRed);

        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);

              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    stampajPromene() {
      

      let _this = this;
      this.isLoading = true;

      this.naziv_fajla = "promene.xls";

      if (this.selectedTab !== 3) {
        this.naslov = "Promene u tank " + this.items.tank.name;

        this.json_fields = {
          Rb: "String",
          Datum: "Date",
          Faza: "String",
          Vino: "String",
          Operacija: "String",
          "Iz tanka": "String",
          "U tank": "String",
          Količina: "Number",
          Talog: "Number",
          Rastur: "Number",
          Opis: "String",
        };

        this.json_fields_type = [
          "String",
          "Date",
          "String",
          "String",
          "String",
          "String",
          "String",
          "Number",
          "Number",
          "Number",
          "String",
        ];
      } else {
        this.naslov = "Ulazi grožđa u tank " + this.items.tank.name;

        this.json_fields = {
          Rb: "String",
          Tank: "String",
          Grožđe: "String",
          Vinograd: "String",
          Berba: "Date",
          "Ulaz u tank": "Date",
          "Udeo u vinu": "Number",
          "Količina gržđa": "Number",
          "Kljuk/šira": "Number",
          "Temperatura grožđa": "String",
          Maceracija: "String",
          Opis: "String",
        };

        this.json_fields_type = [
          "String",
          "String",
          "String",
          "String",
          "Date",
          "Date",
          "Number",
          "Number",
          "Number",
          "String",
          "String",
          "String",
        ];
      }

      this.json_data = [];
      let rbr = 1;

      this.items_promene.forEach(function (entry) {
        let objekat;

        if (_this.selectedTab !== 3)
          objekat = {
            Rb: rbr,
            Datum: _this.formatDateTime(entry.date),
            Faza: entry.phaseAtMoment,
            Vino: entry.wineAtMoment,
            Operacija: _this.prevediOperacijeLok(
              entry.operation,
              entry.pressingFraction
            ),
            "Iz tanka": _this.formatTank_IZ(
              entry.changeOfState,
              entry.tankName,
              null
            ),
            "U tank": _this.formatTank_U(entry.changeOfState, entry.tankName),
            Količina:
              entry.quantity !== null ? entry.quantity + entry.quantityMark : "",
            Talog:
              entry.sediment !== null ? entry.sediment + entry.sedimentMark : "",
            Rastur: entry.outage !== null ? entry.outage + entry.outageMark : "",
            Opis: entry.description,
          };
        else
        objekat = {
          Rb: rbr,
          Tank: entry.tankName,
          "Grožđe": entry.grapeVariety,
          Vinograd: entry.vineyard,
          Berba: _this.formatDate(entry.harvestDate),
          "Ulaz u tank": _this.formatDateTime(entry.entryDate),
          "Udeo u vinu": entry.relativePart,
          "Količina gržđa":
            entry.grapeQuantity,
          "Kljik/Šira":
            entry.stumQuantity,
            "Temperatura grožđa": entry.grapeTemperature !== null ? entry.grapeTemperature : "",
            "Maceracija": entry.maceration !== null ? entry.maceration + entry.maceration : "",
          Opis: entry.description,
        };

        _this.json_data.push(objekat);

        rbr = rbr + 1;
      });

      this.stampaDokumenta();
    },
    stampaDokumenta() {
      let _this = this;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var isLastElement = i == _this.json_data.length - 1;

          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            if (val === null || val === 0 || val === "")
              cellText = document.createTextNode("-");
            else cellText = document.createTextNode(val);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (
              _this.json_fields_type[pomJ] === "Number" ||
              _this.json_fields_type[pomJ] === "StringRight"
            ) {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          if (isLastElement) {
            poslednjiRed = row;
            // row.setAttribute("border", "none");
          }

          tblBody.appendChild(row);
        });

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        var tblBody = document.createElement("tbody");

        tbl.style.margin = "20px 0px 0px 75%";
        tbl.style.width = "25%";
        // tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // tblBody.appendChild(poslednjiRed);

        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);

              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    stampajMerenja() {
      let _this = this;
      this.isLoading = true;

      this.naziv_fajla = "merenja.xls";

      if (this.tip_tanka === 15) {
        if (this.selectedTabMerenja === 0)
          this.naslov = "Merenja za šaržu " + this.items.tank.name;
        else
          this.naslov =
            "Prethodna merenja za vino iz šarže " + this.items.tank.name;

        this.json_fields = {
          Rb: "String",
          Datum: "Date",
          Barik: "String",
          Parametar: "String",
          Količina: "Number",
          Tank: "String",
          Faza: "String",
          Vino: "String",
          "Količina vina": "Number",
        };

        this.json_fields_type = [
          "String",
          "Date",
          "String",
          "String",
          "Number",
          "String",
          "String",
          "String",
          "Number",
        ];
      } else {
        if (this.selectedTabMerenja === 0)
          this.naslov = "Merenja za tank " + this.items.tank.name;
        else
          this.naslov =
            "Prethodna merenja za vino iz tanka " + this.items.tank.name;

        this.json_fields = {
          Rb: "String",
          Datum: "Date",
          Parametar: "String",
          Količina: "Number",
          Tank: "String",
          Faza: "String",
          Vino: "String",
          "Količina vina": "Number",
        };

        this.json_fields_type = [
          "String",
          "Date",
          "String",
          "Number",
          "String",
          "String",
          "String",
          "Number",
        ];
      }

      this.json_data = [];
      let rbr = 1;

      this.items_merenja.forEach(function (entry) {
        let objekat;

        if (_this.tip_tanka === 15) {
          let spisakBarika = "";

          if (entry.tankFromBatchInOperations.length > 0)
            entry.tankFromBatchInOperations.forEach(function (e) {
              if (spisakBarika !== "")
                spisakBarika =
                  spisakBarika + ", " + e.tank.batchPrefix + "|" + e.tank.name;
              else spisakBarika = e.tank.batchPrefix + "|" + e.tank.name;
            });
          else spisakBarika = "Svi barici";

          objekat = {
            Rb: rbr,
            Datum: _this.formatDateTime(entry.date),
            Barik: spisakBarika,
            Parametar: entry.name,
            Količina: entry.quantity + " " + entry.unitOfMeasure,
            Tank: entry.tankName,
            Faza: entry.phaseAtMoment,
            Vino: entry.wineAtMoment,
            "Količina vina":
              entry.wineQuantityAtMoment +
              " " +
              entry.wineQuantityAtMomentUnitOfMeasure,
          };
        } else
          objekat = {
            Rb: rbr,
            Datum: _this.formatDateTime(entry.date),
            Parametar: entry.name,
            Količina: entry.quantity + " " + entry.unitOfMeasure,
            Tank: entry.tankName,
            Faza: entry.phaseAtMoment,
            Vino: entry.wineAtMoment,
            "Količina vina":
              entry.wineQuantityAtMoment +
              " " +
              entry.wineQuantityAtMomentUnitOfMeasure,
          };

        _this.json_data.push(objekat);

        rbr = rbr + 1;
      });

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var isLastElement = i == _this.json_data.length - 1;

          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            if (val === null || val === 0 || val === "")
              cellText = document.createTextNode("-");
            else cellText = document.createTextNode(val);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (
              _this.json_fields_type[pomJ] === "Number" ||
              _this.json_fields_type[pomJ] === "StringRight"
            ) {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          if (isLastElement) {
            poslednjiRed = row;
            // row.setAttribute("border", "none");
          }

          tblBody.appendChild(row);
        });

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        var tblBody = document.createElement("tbody");

        tbl.style.margin = "20px 0px 0px 75%";
        tbl.style.width = "25%";
        // tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // tblBody.appendChild(poslednjiRed);

        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);

              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    stampajSve() {
      this.isLoading = true;
      let _this = this;

      this.naziv_fajla = "troskovi_lansiranja.xls";
      this.naslov = "Sve operacije";

      this.json_fields = {
        Rb: "String",
        Datum: "Date",
        Faza: "String",
        Vino: "String",
        Operacija: "String",
        "Iz tanka": "String",
        "U tank": "String",
        Količina: "Number",
        Talog: "Number",
        Rastur: "Number",
        Opis: "String",
      };

      this.json_fields_type = [
        "String",
        "Date",
        "String",
        "String",
        "String",
        "String",
        "String",
        "Number",
        "Number",
        "Number",
        "String",
      ];

      this.json_data = [];

      let urlLoc =
        "/tank_phase_wine/" + this.tank_phase_vineId + "/all_actions";

      setTimeout(() => {
        this.$http
          .get(this.globalServiceLocation + this.globalPort + urlLoc, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            let rbr = 1;

            response.data.forEach(function (entry) {
              let objekat;

              objekat = {
                Rb: rbr,
                Datum: _this.formatDateTime(entry.date),
                Faza: entry.phaseAtMoment,
                Vino: entry.wineAtMoment,
                Operacija: _this.prevediOperacijeLok(
                  entry.operation,
                  entry.pressingFraction
                ),
                "Iz tanka": _this.formatTank_IZ(
                  entry.changeOfState,
                  entry.tankName,
                  null
                ),
                "U tank": _this.formatTank_U(
                  entry.changeOfState,
                  entry.tankName
                ),
                Količina:
                  entry.quantity !== null
                    ? entry.quantity + entry.quantityMark
                    : "",
                Talog:
                  entry.sediment !== null
                    ? entry.sediment + entry.sedimentMark
                    : "",
                Rastur:
                  entry.outage !== null ? entry.outage + entry.outageMark : "",
                Opis: entry.description,
              };

              _this.json_data.push(objekat);

              rbr = rbr + 1;
            });

            this.stampaDokumenta();
          })
          .catch((e) => {
            if (!e.response) {
              this.isLoading = false;

              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          urlLoc +
                          strDate +
                          strDateDo,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        let rbr = 1;

                        response.data.forEach(function (entry) {
                          let objekat;

                          objekat = {
                            Rb: rbr,
                            Datum: _this.formatDateTime(entry.date),
                            Faza: entry.phaseAtMoment,
                            Vino: entry.wineAtMoment,
                            Operacija: _this.prevediOperacijeLok(
                              entry.operation,
                              entry.pressingFraction
                            ),
                            "Iz tanka": _this.formatTank_IZ(
                              entry.changeOfState,
                              entry.tankName,
                              null
                            ),
                            "U tank": _this.formatTank_U(
                              entry.changeOfState,
                              entry.tankName
                            ),
                            Količina:
                              entry.quantity !== null
                                ? entry.quantity + entry.quantityMark
                                : "",
                            Talog:
                              entry.sediment !== null
                                ? entry.sediment + entry.sedimentMark
                                : "",
                            Rastur:
                              entry.outage !== null
                                ? entry.outage + entry.outageMark
                                : "",
                            Opis: entry.description,
                          };

                          _this.json_data.push(objekat);

                          rbr = rbr + 1;
                        });

                        this.isLoading = false;
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }, 10);
    },
  },
  mounted() {
    // serverBus.$off("room");
  },
};
</script>
<style scoped lang='scss'>
// @import "./../parts/../../assets/sass/parts/modalStyles";

//../
@import "./../parts/../../assets/sass/parts/modalStyles_siri_modal";
/*#Dialog {*/
/*max-width: 700px;*/
/*&__Overlay {*/
/*display: none;*/
/*z-index: 201;*/
/*}*/
/*&__Content {*/
/*display: none;*/
/*z-index: 202;*/
/*.v-card__title {*/
/*padding-left: 30px;*/
/*padding-bottom: 0;*/
/*}*/
/*.container {*/
/*padding-top: 0;*/
/*}*/
/*}*/
/*}*/

/*.v-card__title {*/
/*padding-top: 15px;*/
/*justify-content: space-between;*/
/*}*/

/*#closeModalBtn {*/
/*width: 70px;*/
/*&:before {*/
/*background-color: transparent;*/
/*}*/
/*}*/

#FloatingButton {
  background-image: url("../../assets/menuIcons/ico-print.png");
  background-size: cover; /* <------ */
  background-repeat: no-repeat;
  background-position: center center; /* optional, center the image */

  object-fit: cover;

  // right: 10px;
  // bottom: 20px;
  width: 40px;
  height: 40px;

  float: right;
  // font-size: 35px;
  border-radius: 50%;
  // color: #ffffff;
  // background-color: #018389;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transition: 0.2s ease-in-out;
  p {
    // position: relative;
    text-align: right;
    // width: 100%;
    // height: 100%;
    i {
      // position: absolute;
      left: 15px;
      top: 15px;
      transform: rotate(45deg);
      color: #ffffff;
    }
  }
  &:active,
  &:focus {
    box-shadow: none;
  }
}

#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  // position: relative;
  text-align: right;
}

button:hover {
  transform: scale(1.3);
  transition: all 0.4s ease-in-out;
}
</style>